export default __webpack_public_path__ + "static/realWorldImg2-64bdc7773ac6328b1dca5ba2060d4131.png";